(function () {
    'use strict';

    angular.module("imApp").factory("prodGrp4Service", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3080,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3081,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3082,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();